var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _path10, _path11;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageUsers(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ffdb80;}.cls-2{fill:#2d4356;}.cls-3{fill:#ad9359;opacity:0.45;}.cls-4{fill:#f9edd2;opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chatting messaging app send word chat smartphone technology bubble discussion_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,56A16,16,0,0,1,62,40H76L74.63,19.5s-2-4.62-11.87-4.87S18,15.75,18,15.75,2.75,11.63,2,25.5,2,64.6,2,64.6s1.63,7.5,11.13,7.27V82L27.25,71H46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116,44H62A12,12,0,0,0,50,56V92a12,12,0,0,0,12,12h40l11.65,10.49a2,2,0,0,0,2.15.34A2,2,0,0,0,117,113v-9a12,12,0,0,0,11-12V56A12,12,0,0,0,116,44Zm8,48a8,8,0,0,1-7,7.93V98.15a2,2,0,0,0-4,0v10.36l-16.66-15a2,2,0,1,0-2.68,3L97.57,100H62a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h54a8,8,0,0,1,8,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124,56V92a8,8,0,0,1-7,7.93V98.15a2,2,0,0,0-4,0v10.36l-16.66-15a2,2,0,1,0-2.68,3L97.57,100H62a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h54A8,8,0,0,1,124,56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.34,66.49a2,2,0,1,0-2.68-3L15,78.51V68.15a2,2,0,0,0-4,0v1.78A8,8,0,0,1,4,62V25a8,8,0,0,1,8-8H66a8,8,0,0,1,8,8V40h4V25A12,12,0,0,0,66,13H12A12,12,0,0,0,0,25V62A12,12,0,0,0,11,73.95V83a2,2,0,0,0,3.34,1.49L26,74H46V70H30.43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124,90v2a8,8,0,0,1-7,7.93V98.15a2,2,0,0,0-4,0v-2a2,2,0,0,1,4,0v1.78A8,8,0,0,0,124,90Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124,56v2a8,8,0,0,0-8-8H62a8,8,0,0,0-8,8V56a8,8,0,0,1,8-8h54A8,8,0,0,1,124,56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113,106.51v2l-16.66-15a2,2,0,0,0-2.83.15,1.51,1.51,0,0,0-.24.34,2,2,0,0,1,3.07-2.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.57,100H62a8,8,0,0,1-8-8V90a8,8,0,0,0,8,8H95.34Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.73,64a1.51,1.51,0,0,0-.24-.34,2,2,0,0,0-2.83-.15L15,78.51v-2l16.66-15A2,2,0,0,1,34.73,64Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "46 68 46 70 30.43 70 32.66 68 46 68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15,66.15v2a2,2,0,0,0-4,0v1.78A8,8,0,0,1,4,62V60a8,8,0,0,0,7,7.93V66.15a2,2,0,0,1,4,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74,25v2a8,8,0,0,0-8-8H12a8,8,0,0,0-8,8V25a8,8,0,0,1,8-8H66A8,8,0,0,1,74,25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageUsers);
export default __webpack_public_path__ + "static/media/messageUsers.8eb9315f5398e649ecb7e95d6ba6f0d2.svg";
export { ForwardRef as ReactComponent };